<template>
    <div>
        <div v-show="!premiumSingleChat">
            <div class="flex items-center sm:!py-5 !py-0 sm:!px-10 !px-7">
                <v-badge overlap bordered :content="unreadCount" :value="unreadCount" :color="colorAsRoute"
                    class="text_color_custom " dark bottom>
                    <Icon icon="teenyicons:message-text-alt-outline" class="!text-3xl" :color="colorAsRoute" />
                </v-badge>
                <v-card-title :class="`${routeLink}_fortext !text-3xl !font-semibold`">Chats</v-card-title>
            </div>

            <v-row class="pa-0 ma-0" no-gutters>
                <v-col cols="12" class="">

                    <comet-chat-user-list :class="`premium_user_list ${routeLink}-premium_user_list `" :item="item"
                        :type="type" :theme="theme" :enable-close-menu="enableCloseMenu" @action="actionHandler"
                        :friendsOnly="true" key="mainList" />
                </v-col>
            </v-row>
        </div>
        <v-container fluid class="pa-0 " v-if="premiumSingleChat">
            <comet-chat-outgoing-call :item="item" :type="type" :theme="themeValue" :incoming-call="incomingCall"
                :outgoing-call="outgoingCall" :logged-in-user="loggedInUser" @action="actionHandler" />
            <comet-chat-messages :key="item.id" class="w-full  overflow-y-auto  rounded-xl" style="height: 100%"
                :tab="tab" :item="item" :type="type" :theme="themeValue" :call-message="callMessage"
                :logged-in-user="loggedInUser" :group-messages="groupMessages"
                :action-from-listener="actionFromListener" :composed-thread-message="composedThreadMessage"
                @action="actionHandler" />

        </v-container>
    </div>
</template>

<script>
import { Icon } from '@iconify/vue2';

import {
    COMETCHAT_CONSTANTS,
    DEFAULT_OBJECT_PROP,
    DEFAULT_STRING_PROP,
    DEFAULT_BOOLEAN_PROP,
} from "../../../../chatApp/src/resources/constants";

import {
    cometChatScreens,
    cometChatCommon,
} from "../../../../chatApp/src/mixins";
import { CometChatManager } from "../../../../chatApp/src/util/controller";

import {
    CometChatMessages,
    CometChatImageViewer,
    CometChatMessageThread,
} from "../../../../chatApp/src/components/Messages";
import { CometChatUserDetails } from "../../../../chatApp/src/components/Users";
import { CometChatGroupDetails } from "../../../../chatApp/src/components/Groups";
import {
    CometChatIncomingCall,
    CometChatOutgoingCall,
} from "../../../../chatApp/src";

import CometChatNavBar from "../../../../chatApp/src/components/CometChatUI/CometChatNavBar/CometChatNavBar";

import { theme } from "../../../../chatApp/src/resources/theme";

import * as style from "../../../../chatApp/src/components/CometChatUI/style";

import NoCompSelected from "../../../../components/noselection/NoCompSelected.vue";
import { CometChatUI, CometChatUserList } from "../../../../chatApp/src";
import PremiumChat from './PremiumChat.vue';
export default {
    components: {
        NoCompSelected,
        CometChatUserList,
        CometChatMessages,
        CometChatUI,
        CometChatNavBar,
        CometChatImageViewer,
        CometChatIncomingCall,
        CometChatOutgoingCall,
        CometChatUserDetails,
        CometChatGroupDetails,
        CometChatMessageThread,
        Icon,
        PremiumChat
    },
    mixins: [cometChatScreens, cometChatCommon],
    props: {
        /**
         * Theme of the UI.
         */
        theme: { ...DEFAULT_OBJECT_PROP },
        /**
         * Current active tab.
         * @values conversations, contacts, groups, info
         */
        tab: { ...DEFAULT_STRING_PROP },
        /**
         * The selected chat item object.
         */
        item: { ...DEFAULT_OBJECT_PROP },
        /**
         * Type of chat item.
         */
        type: { ...DEFAULT_STRING_PROP },
        /**
         * Last message in message list.
         */
        lastMessage: { ...DEFAULT_OBJECT_PROP },
        /**
         * The group selected to leave.
         */
        groupToLeave: { ...DEFAULT_OBJECT_PROP },
        /**
         * The group selected to update.
         */
        groupToUpdate: { ...DEFAULT_OBJECT_PROP },
        /**
         * The group selected to delete.
         */
        groupToDelete: { ...DEFAULT_OBJECT_PROP },
        /**
         * Shows/hides the close menu button.
         */
        enableCloseMenu: { ...DEFAULT_BOOLEAN_PROP },
        /**
         * Message marked to read.
         */
        messageToMarkRead: { ...DEFAULT_OBJECT_PROP },
        outgoingCall: { ...DEFAULT_OBJECT_PROP },
    },
    data() {
        return {
            // item: {},
            // type: "user",
            premiumSingleChat: false,
            imageView: null,
            darkTheme: false,
            // lastMessage: {},
            callMessage: {},
            // groupToLeave: {},
            // groupToDelete: {},
            // groupToUpdate: {},
            groupMessages: [],
            viewSidebar: false,
            incomingCall: null,
            // outgoingCall: null,
            loggedInUser: null,
            // tab: "conversations",
            // messageToMarkRead: {},
            threadMessageItem: {},
            actionFromListener: {},
            viewDetailScreen: false,
            threadMessageType: null,
            threadMessageParent: {},
            viewThreadMessage: false,
            composedThreadMessage: {},
            baseUrl: "http://6537-115-167-64-252.ngrok.io",
        };
    },
    computed: {
        unreadCount() {
            return this.$store.getters.unreadMessages
        },
        chatSelector() {
            return this.$route.params.id ? true : false;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },

        /**
         * Computed styles for the component.
         */
        styles() {
            return {
                main: style.unifiedMainStyle(
                    this.viewThreadMessage,
                    this.viewDetailScreen
                ),
                secondary: style.unifiedSecondaryStyle(
                    this.themeValue,
                    this.viewThreadMessage
                ),
                root: style.unifiedStyle(this.themeValue),
                placeholder: style.unifiedPlaceholderStyle(this.themeValue),
                sidebar: style.unifiedSidebarStyle(this.themeValue, this.viewSidebar),
            };
        },
        /**
         * Theme computed using default theme and theme coming from prop.
         */

        themeValue() {
            return Object.assign({}, theme, this.theme);
        },
        /**
         * Placeholder message when chat item is not selected.
         */
        placeholderMessage() {
            return this.STRINGS[
                this.tab === "info"
                    ? "NO_TAB_SELECTED_MESSAGE"
                    : "NO_ITEM_SELECTED_MESSAGE"
            ];
        },
        /**
         * Local string constants.
         */
        STRINGS() {
            return COMETCHAT_CONSTANTS;
        },
    },
    methods: {
        /**
         * Handler for emitted action events
         */
        actionHandler({
            action,
            tab,
            item,
            call,
            type,
            count,
            group,
            members,
            message,
            messages,
            incomingCall,
            rejectedCall,
        }) {
            switch (action) {
                case "item-click":
                    this.itemClicked(item, type);
                    break;
                case "tabChanged":
                    this.item = {};
                    this.changeTab(tab);
                    break;
                case "blockUser":
                    this.blockUser();
                    break;
                case "unblockUser":
                    this.unblockUser();
                    break;
                case "audioCall":
                    this.audioCall();
                    break;
                case "videoCall":
                    this.videoCall();
                    break;
                case "viewDetail":
                case "closeDetailClicked":
                    this.toggleDetailView();
                    break;
                case "menuClicked":
                    this.item = {};
                    this.toggleSideBar();
                    break;
                case "closeMenuClicked":
                    this.toggleSideBar();
                    break;
                case "groupUpdated":
                    this.groupUpdated(item, count);
                    break;
                case "groupDeleted":
                    this.deleteGroup(group);
                    break;
                case "leftGroup":
                    this.leaveGroup(group);
                    break;
                case "membersUpdated":
                    this.updateMembersCount(count);
                    break;
                case "viewMessageThread":
                    this.viewMessageThread(message);
                    break;
                case "closeThreadClicked":
                    this.closeThreadMessages();
                    break;
                case "threadMessageComposed":
                    this.onThreadMessageComposed(messages);
                    this.updateLastMessage(messages[0]);
                    break;
                case "acceptIncomingCall":
                    this.acceptIncomingCall(incomingCall);
                    break;
                case "acceptedIncomingCall":
                    this.callInitiated(call);
                    break;
                case "rejectedIncomingCall":
                    this.rejectedIncomingCall(incomingCall, rejectedCall);
                    break;
                case "outgoingCallRejected":
                case "outgoingCallCancelled":
                case "callEnded":
                    this.outgoingCallEnded(call);
                    break;
                case "userJoinedCall":
                case "userLeftCall":
                    this.appendCallMessage(call);
                    break;
                case "viewActualImage":
                    this.setImageView(message);
                    break;
                case "closeActualImage":
                    this.setImageView(null);
                    break;
                case "membersAdded":
                    this.membersAdded(members, message);
                    break;
                case "memberUnbanned":
                    this.memberUnbanned(members, message);
                    break;
                case "memberScopeChanged":
                    this.memberScopeChanged(members, message);
                    break;
                case "messageDeleted":
                    this.closeThreadMessages();
                    break;
                case "messageComposed":
                case "lastMessageEdited":
                case "lastMessageDeleted":
                    this.updateLastMessage(messages[0]);
                    break;
                case "messageEdited":
                    this.updateThreadMessage(message);
                    break;
                case "listenerData":
                    this.actionFromListener = { action: action, messages: [...messages] };
                    break;
                default:
                    break;
            }

        },
        /**
         * Changes tab
         */
        changeTab(tab) {
            this.tab = tab;
            this.imageView = null;
            this.viewDetailScreen = false;
            this.viewThreadMessage = false;
        },


    },
    watch: {
        '$route.query': {
            handler: function (id) {
                if (id.uid) {
                    this.premiumSingleChat = true;
                } else {
                    this.premiumSingleChat = false;
                }
            },
            deep: true,
            immediate: true,
        }
    },
    beforeMount() {
        if (!Object.keys(this.item).length) {
            this.toggleSideBar();
        }

        (async () => {
            try {
                this.loggedInUser = await new CometChatManager().getLoggedInUser();
            } catch (error) {
                this.logError("[CometChatUnified] getLoggedInUser error", error);
            }
        })();
    },

    created() {

    }
};
</script>

<style scoped>
.lesbian_sideGradient {

    background: rgb(59, 0, 68);
    background: linear-gradient(90deg, rgb(37 0 42) 0%, rgb(87 1 133) 38%, rgba(130, 5, 197, 1) 100%);
    position: relative;
    z-index: 1;

}

.gay_sideGradient {
    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_sideGradient {

    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);

}


.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(360deg, rgb(0 158 255) 22%, rgba(0, 240, 255, 1) 50%, rgba(0, 156, 255, 1) 64%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_color_custom:deep(.v-badge__badge) {
    color: black;
}

.premium_user_list:deep(.v-list-item) {
    border: 1px solid gray !important;
    border-radius: 25px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.lesbian-premium_user_list:deep(.v-item--active) {
    border-color: #9120d1 !important;
    box-shadow: 0px 0px 10px 0px #9120d1a6 !important;
}

.straight-premium_user_list:deep(.v-item--active) {
    border-color: #da930f !important;
    box-shadow: 0px 0px 10px 0px #b38123 !important;
}

.gay-premium_user_list:deep(.v-item--active) {
    border-color: #00b2ff !important;
    box-shadow: 0px 0px 10px 0px #00b5ff !important;
}

.lesbian-premium_user_list:deep(input) {
    border: 1px solid #9120d1 !important;
    border-radius: 15px !important;
}

.straight-premium_user_list:deep(input) {
    border: 1px solid #da930f !important;
    border-radius: 15px !important;
}

.gay-premium_user_list:deep(input) {
    border: 1px solid #00b2ff !important;
    border-radius: 15px !important;
}

.premium_user_list:deep(.search_input),
.premium_user_list:deep(.v-list) {
    padding: 15px 40px !important;

}



.premium_user_list:deep(.v-list-item--link:before) {
    border-radius: 25px !important;

}

@media only screen and (max-width:768px) {

    .premium_user_list:deep(.search_input),
    .premium_user_list:deep(.v-list) {
        padding: 15px 20px !important;

    }
}
</style>